/* eslint-disable */
import auth0 from "auth0-js";

window.webAuth = new auth0.WebAuth({
  domain: window.__AUTH0_DOMAIN__,
  clientID: window.__AUTH0_CLIENT_ID__,
  responseType: "code"
});
